import { Component, OnInit, Injector } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ErrorMapperService } from '../../../shared/services/error-mapper.service';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent extends ModalBaseComponent {

  errors: any[];
  successes: any[];
  operationName: string;
  generateErrorMessage = ErrorMapperService.generateErrorMessage;
  errorTitle: string;


  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
    console.log('ErrorModalComponent');

  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/error-modal/error-modal.component.ts